import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_ACCOUNT_ELIGIBILITY } from 'actions/apiActionConstants'
import requestLoyaltyAccountEligibility from 'api/loyalty/requestLoyaltyAccountEligibility'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getIsLoyaltyAccountClosed from 'loyalty/selectors/getIsLoyaltyAccountClosed'

export function fetchLoyaltyAccountEligibility(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const memberId = state.auth.account.memberId
    const hasLoyaltyAccount = getHasLoyaltyAccount(state)
    const loyaltyEligibility = state.loyalty.eligibilityTier

    if (
      !getIsLoyaltyEnabled(state) ||
      !memberId ||
      hasLoyaltyAccount ||
      getIsLoyaltyAccountClosed(state) ||
      loyaltyEligibility.data ||
      loyaltyEligibility.fetching ||
      loyaltyEligibility.error
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_ACCOUNT_ELIGIBILITY,
      request: () => requestLoyaltyAccountEligibility(memberId),
    })
  }
}

export default fetchLoyaltyAccountEligibility
